import React from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";
import { usePaymentContext } from "@/features/accounts/payment/scraping/contexts/payment-context";
import { useInstitutionsContext } from "@/features/institutions/contexts/institutions-context";
import { useInstitutionsServices } from "@/features/institutions/hooks/use-institutions-services";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";
import { useTradeJumpContext } from "@/features/trade-jump/contexts/trade-jump-context";

interface Props {
  isOwner: boolean;
  maintenance?: boolean;
  passbookType: string;
  scrapeType: number;
  onTapCloseModal: () => void;
}

// 明細オプションモーダル
export const TradesOptionModal= ({ isOwner, maintenance, passbookType, scrapeType, onTapCloseModal }: Props) => {
  const { setOpenHomeModal } = useModalContext();
  // 口座種類ごとにclassNameを分岐
  let addAccountClass = "btn-bank";
  if (passbookType === "01") {
    addAccountClass = "btn-bank";
  } else if (passbookType === "19659" || passbookType === "19660") {
    addAccountClass = "btn-card";
  } else if (passbookType === "10") {
    addAccountClass = "btn-emoney";
  } else if (passbookType === "20") {
    addAccountClass = "btn-app";
  }
  const {
    setSelectedInstitutionService,
  } = useInstitutionsContext();
  const {
    setProcessType,
  } = usePaymentContext();
  const { 
    getInstitutionsServices,
  } = useInstitutionsServices();
  const { selectedAccount } = useAccountGroupsContext();
  const { syncJump } = useTradeJumpContext();

  return (
    <BasePageModal
      title="オプション"
      className="md-list-option"
      handleClose={() => {
        onTapCloseModal();
      }}
    > 
      <ul>
        {!syncJump && isOwner && !maintenance && selectedAccount?.authorizationStatus !== 4 && (
        (   passbookType === "01"
          || passbookType === "19659"
          || passbookType === "19660"
          || passbookType === "03"
          || passbookType === "10"
          || passbookType === "20"
        ) && (
        <li>
          <button
            type="button"
            className="btn-lock"
            onClick={async () => {
          if (!selectedAccount) {
            return;
          }
          const res = await getInstitutionsServices(
            selectedAccount.industryCode,
            selectedAccount.companyCode,
            selectedAccount.branchCode,
          );
          if (res) {
            const selectedService = res.find((service) => service.serviceCode === selectedAccount.serviceCode);
            setSelectedInstitutionService(selectedService);
            if (passbookType === "01"
              || passbookType === "19659"
              || passbookType === "19660"
              || passbookType === "20"
              || (passbookType === "03" && scrapeType === 3)
              || (passbookType === "10" && scrapeType === 3)
            ) {
              setOpenHomeModal("SiteReauth");
            } else {
              setProcessType("upd");
              setOpenHomeModal("PaymentLoginInfo");
            }
          }
        }}
          >
            認証情報の変更
          </button>
        </li>
        )
        )}
        {!syncJump && isOwner && !maintenance && selectedAccount?.authorizationStatus !== 4 &&
          (  (passbookType === "01" && !(selectedAccount?.companyCode === "10005" && selectedAccount?.serviceCode === "1020"))
          || passbookType === "03"
          || passbookType === "10"
        ) && (
        <li>
          <button
            type="button"
            className={addAccountClass}
            onClick={() => setOpenHomeModal("SyncAccountsStart") }
          >
            口座の追加
          </button>
        </li>
        )}
        <li>
          <button
            type="button" 
            className="btn-history"
            onClick={() => setOpenHomeModal("History")}
          >
            取込履歴
          </button>
        </li>
        {!syncJump && isOwner && (
        <li>
          <button
            type="button"
            className="btn-edit2"
            onClick={() => setOpenHomeModal("EditName")}
          >
            Web明細帳名の変更
          </button>
        </li>
        )}
        {!syncJump && isOwner && (
        <li>
          <button
            type="button"
            className="btn-delete"
            onClick={() => setOpenHomeModal("Delete")}
          >
            Web明細帳を削除
          </button>
        </li>
        )}
      </ul>
    </BasePageModal>
  );
};
